import { motion } from "framer-motion";
import { useSiteSettings } from "@/hooks/useSiteSettings";

const WALL_IMG =
  "https://customer-assets.emergentagent.com/job_ded0e787-ce73-4799-bf5f-3aa93c0f5b06/artifacts/e0itwate_81247389-BE6F-4C43-BDB6-AB97BB569FF1.jpeg";

const stats = [
  { value: "2022", label: "Year Formed" },
  { value: "60s–00s", label: "Eras Covered" },
  { value: "4", label: "Legends Opened For" },
  { value: "1", label: "Studio Album" },
];

export const About = () => {
  const s = useSiteSettings();
  return (
    <section
      id="about"
      data-testid="bio-section"
      className="relative bg-[#0A0A0A] py-24 md:py-32 px-6 md:px-16"
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Image */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative grain-overlay">
            <img
              src={WALL_IMG}
              alt="The Randy Loveless Band against graffiti wall"
              width="900"
              height="560"
              loading="lazy"
              decoding="async"
              className="w-full h-[420px] md:h-[560px] object-cover"
            />
            <div className="absolute -bottom-4 -right-4 bg-[#B91C1C] text-white font-oswald uppercase tracking-[0.2em] text-xs px-5 py-3">
              Est. 2022
            </div>
          </div>
        </motion.div>

        {/* Text */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="lg:col-span-7"
        >
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#DC2626]" />
            <span className="font-oswald text-xs uppercase tracking-[0.3em] text-[#DC2626]">
              Our Story
            </span>
          </div>
          <h2 className="font-anton uppercase text-white text-5xl md:text-6xl lg:text-7xl leading-[0.9] mb-8">
            Forged in Montana.
            <br />
            <span className="text-[#B91C1C]">Played Everywhere Else.</span>
          </h2>
          <p
            data-testid="bio-text"
            className="text-white/80 text-lg md:text-xl font-manrope leading-relaxed whitespace-pre-wrap"
          >
            {s.bio || "Formed by Randy Loveless from the Rockaholics in 2022. We play classic rock from the 60s-00's. Randy released his first CD (Trapped in a Montana Winter) in Nov. 2024. Randy has opened for Rick Derringer, Great White, Badfinger and ZZ Top."}
          </p>

          <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10">
            {stats.map((s) => (
              <div
                key={s.label}
                className="bg-[#0A0A0A] p-6 hover:bg-[#111] transition-colors"
                data-testid={`stat-${s.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                <div className="font-anton text-3xl md:text-4xl text-[#DC2626] mb-1">
                  {s.value}
                </div>
                <div className="font-oswald uppercase tracking-[0.18em] text-xs text-white/60">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
